import { Grid, styled } from "@mui/material";

export const CollapseContainer = styled(Grid)(() => ({
  marginTop: "24px",
  marginBottom: "8px",
}));

export const CollapseBody = styled("div")(() => ({
  marginLeft: "16px",
}));
